import { Counter, CounterProps } from 'common/components/Counter/Counter.tsx';
import { CellLayout } from 'common/components/ConfigurableTable/Components/Cells/CellLayout.tsx';

export type CounterCellProps = {
  value: number;
  variant?: CounterProps['variant'];
};

export const CounterCell = ({ value, variant }: CounterCellProps) => {
  return (
    <CellLayout>
      <Counter count={value} variant={variant} data-testid="primaryText" />
    </CellLayout>
  );
};

export const CounterCellSuccess = ({ value }: CounterCellProps) => {
  return <CounterCell value={value} variant="success" />;
};

export const CounterCellFailed = ({ value }: CounterCellProps) => {
  return <CounterCell value={value} variant="error" />;
};
